import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { SchoolStandardLayoutModule } from '../../../school/layouts/school-standard-layout/school-standard-layout.module';
import { SchoolSingleColumnLayoutModule } from '../../../school/layouts/school-single-column-layout/school-single-column-layout.module';
import { ToggleService } from '../../services/toggle/toggle.service';
import { OpStandardLayoutComponent } from '../op-standard-layout/op-standard-layout.component';

@Component({
  selector: 'layout-switcher',
  templateUrl: './layout-switcher.component.html',
  imports: [
    CommonModule,
    RouterOutlet,
    OpStandardLayoutComponent,
    SchoolStandardLayoutModule,
    SchoolSingleColumnLayoutModule,
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class LayoutSwitcherComponent implements OnInit {
  public layoutVariant: 'onePortalLayout' | 'legacy' | 'legacySingleColumn' | 'fullScreen' = 'legacy';

  private readonly onePortalToggleKey = 'TOGGLE_ONE_PORTAL';

  constructor (
    private toggleService: ToggleService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit (): void {
    // will add more variants as we migrate more pages to one portal, for now we will just switch between legacy and one portal layouts
    const isOnePortalEnabled = this.toggleService.getToggleState(this.onePortalToggleKey);
    const legacyLayoutVariant = this.activatedRoute.snapshot.data.legacyLayoutVariant;
    // will add more variants as we migrate more pages to one portal, for now we will just switch between legacy and one portal layouts
    if (isOnePortalEnabled) {
      this.layoutVariant = 'onePortalLayout';
      return;
    }

    switch (legacyLayoutVariant) {
      case 'singleColumn':
        this.layoutVariant = 'legacySingleColumn';
        break;
      // No layout wrapper — the page (e.g. the data grid) renders full-screen as
      // it did before One Portal.
      case 'fullScreen':
        this.layoutVariant = 'fullScreen';
        break;
      default:
        this.layoutVariant = 'legacy';
    }
  }
}
